import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import user from '../../../js/stores/user.js';
import language from '../../../js/stores/language.js';
import carLoan from '../../../js/stores/car-loan.js';
import * as dayjs from 'dayjs';
import GoogleMapItem from '../../components/google-map.f7.html';
var StoppingTab = function StoppingTab(props, _ref) {
  var $h = _ref.$h,
    $f7 = _ref.$f7,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted;
  var locale = language.getters.Item.value;
  var data = props.data;
  var isOwner = user.getters.carId.value == props.data.CarMainData.CarId ? true : false;
  var isBorrower = user.getters.carId.value != props.data.CarMainData.CarId ? true : false;
  var isDisabled = true;
  var returnAppointmentDateTime;
  var returnDate = props.data.CarLoanData.ReturnAppointmentDate;
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var timeElapsed, today;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          isDisabled = props.data.CarLoanData.CarLoanStatusId == 5 && isBorrower ? false : true;
          timeElapsed = Date.now();
          today = new Date(timeElapsed);
          returnAppointmentDateTime = $f7.calendar.create({
            inputEl: '#return-appointment-date',
            openIn: 'customModal',
            timePicker: true,
            footer: true,
            toolbarCloseText: locale.translate('general.done'),
            disabled: {
              from: new Date(2000, 0, 1),
              to: new Date(today.getFullYear(), today.getMonth(), today.getDate())
            },
            on: {
              closed: function closed(e) {
                if (e.value === undefined) return;
                var dates = e.value;
                var startDate = dayjs(dates[0]).format('YYYY-MM-DD HH:mm:00');
                returnDate = "".concat(startDate);
                $update();
              }
            }
          });
          $update();
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  var showAppointmentDialog = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            returnAppointmentDateTime.open();
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function showAppointmentDialog() {
      return _ref3.apply(this, arguments);
    };
  }();
  var setReturnAppointment = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var appointmentDate, appointmentPlace, formData;
      return _regeneratorRuntime.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            appointmentDate = returnAppointmentDateTime.value;
            appointmentPlace = document.getElementById('return-appointment-place-address').value;
            if (!(appointmentDate == undefined || appointmentDate.length < 1)) {
              _context4.next = 1;
              break;
            }
            $f7.toast.show({
              text: locale.translate('loan.appointment.noAppointmentSelected')
            });
            return _context4.abrupt("return");
          case 1:
            if (!(appointmentPlace === "")) {
              _context4.next = 2;
              break;
            }
            $f7.toast.show({
              text: locale.translate('loan.appointment.noPlaceEntered')
            });
            return _context4.abrupt("return");
          case 2:
            formData = $f7.form.convertToData('#stopping-form');
            formData["CarLoanId"] = data.CarLoanData.CarLoanId;
            formData["CarId"] = data.CarMainData.CarId;
            formData["LenderId"] = data.CarMainData.ContactId;
            formData["BorrowerId"] = data.CarLoanData.BorrowerId;
            $f7.dialog.confirm(locale.translate('loan.backAppointment.confirmMeeting', [appointmentDate, appointmentPlace]), /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
              var result;
              return _regeneratorRuntime.wrap(function (_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 1;
                    return carLoan.dispatch('setReturnAppointment', formData);
                  case 1:
                    result = _context3.sent;
                    if (!(result.status !== undefined && result.status !== 200)) {
                      _context3.next = 2;
                      break;
                    }
                    $f7.toast.show({
                      text: result.data.messages.error
                    });
                    return _context3.abrupt("return");
                  case 2:
                    $f7.toast.show({
                      text: locale.translate('loan.backAppointment.messageMeeting', [appointmentDate, appointmentPlace])
                    });
                    $f7.views.main.router.navigate('/', {
                      reloadCurrent: true,
                      ignoreCache: true
                    });
                  case 3:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3);
            })));
          case 3:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function setReturnAppointment() {
      return _ref4.apply(this, arguments);
    };
  }();
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page-content tab" id="tab-6-stopping">
  <div class="block ${isDisabled ? $h`disabled` : $h``}">
    <form id="stopping-form" class="list no-hairlines-md">
      <div class="block-title">${locale.translate('loan.appointment.labelData')}</div>
      <div class="list">
        <ul>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${locale.translate('loan.backAppointment.selectAppointmentDate')}</div>
              <div class="item-input-wrap">
                <input id="return-appointment-date" name="CarAppointmentDate" type="text" autocomplete="off" placeholder="${locale.translate('general.date')}"
                  readonly="readonly" @click="${showAppointmentDialog}" value="${returnDate}" />
              </div>
            </div>
          </li>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${locale.translate('loan.backAppointment.selectAppointmentPlace')}</div>
              <div class="item-input-wrap">
                <input id="return-appointment-place-address" name="CarAppointmentAddress" type="text" autocomplete="off" placeholder="${locale.translate('general.place')}" value="${props.data.AppointmentData.CarAppointmentAddress}" />
                <input id="return-appointment-place-coords-latitude" name="CarAppointmentLatitude" type="hidden" value="props.data.AppointmentData.CarAppointmentLatitude"/>
                <input id="return-appointment-place-coords-longitude" name="CarAppointmentLongitude" type="hidden" value="props.data.AppointmentData.CarAppointmentLongitude"/>
              </div>
            </div>
            <div class="item-after">
              <a href="#" class="button button-fill button-raised popup-open location-button" data-popup=".return-appointment-popup">
                <i class="icon material-symbols-outlined">location_on</i>
              </a>
            </div>
          </li>
        </ul>
      </div>
    </form>
    ${!isDisabled ? $h`
    <div class="block block-strong">
      <p class="grid grid-cols-3 xlarge-grid-cols-3">
        <div></div>
        <div>
          <a href="#" class="button button-small button-fill button-raised color-green" @click="${setReturnAppointment}">
            <span class="material-symbols-outlined">file_map</span>${locale.translate('general.accept')}
          </a>
        </div>
        <div></div>
      </p>
    </div>
    ` : $h`
    <span></span>
    `}
  </div>
  <${GoogleMapItem} selector="return-appointment"/>
</div>
`
    }
    ;
};
export default StoppingTab;